import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen theme-bg-primary flex items-center justify-center py-12 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full h-[calc(100vh-200px)] overflow-y-auto">
        <div className="theme-bg-secondary py-8 px-4 shadow-xl sm:rounded-lg sm:px-10 theme-border border pb-[70px]">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-3">
              <Logo size="xxxl" />
            </div>
            <h2 className="text-1xl theme-text-secondary mb-4">
              Let's respect the market
            </h2>
            <h1 className="text-3xl font-bold theme-text-primary mb-4">
              Terms and Conditions
            </h1>
            <p className="theme-text-quaternary text-sm">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-invert max-w-none theme-text-secondary space-y-6">
            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                1. Acceptance of Terms
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                By accessing and using Live Trading Studio, you accept and agree
                to be bound by the terms and provision of this agreement. If you
                do not agree to abide by the above, please do not use this
                service.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                2. Description of Service
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                Live Trading Studio provides a professional platform for
                advanced trading and market analysis. Our services include
                real-time market data, trading tools, portfolio management, and
                educational resources.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                3. User Responsibilities
              </h3>
              <ul className="list-disc list-inside theme-text-secondary leading-relaxed space-y-2 ml-4">
                <li>You must be at least 18 years old to use our services</li>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your account
                </li>
                <li>You agree to use the service only for lawful purposes</li>
                <li>
                  You must not engage in any fraudulent or manipulative trading
                  activities
                </li>
                <li>
                  You are responsible for all trading decisions and their
                  outcomes
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                4. Risk Disclosure
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                Trading involves substantial risk of loss and is not suitable
                for all investors. The value of your investment may go down as
                well as up. Past performance does not guarantee future results.
                You should carefully consider your investment objectives, risks,
                and costs before trading.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                5. Intellectual Property
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                All content, features, and functionality of Live Trading Studio,
                including but not limited to text, graphics, logos, and
                software, are owned by us and are protected by international
                copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                6. Limitation of Liability
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                Live Trading Studio shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages,
                including without limitation, loss of profits, data, use,
                goodwill, or other intangible losses, resulting from your use of
                the service.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                7. Termination
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We may terminate or suspend your account and access to the
                service immediately, without prior notice or liability, for any
                reason whatsoever, including without limitation if you breach
                the Terms.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                8. Changes to Terms
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We reserve the right to modify or replace these Terms at any
                time. If a revision is material, we will try to provide at least
                30 days notice prior to any new terms taking effect.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                9. Contact Information
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                If you have any questions about these Terms and Conditions,
                please contact us at support@livetradingstudio.com
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t theme-border">
            <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
              <Link
                to="/register"
                className="text-[#2AB7A6] hover:text-[#25A395] font-medium"
              >
                ← Back to Registration
              </Link>
              <Link
                to="/privacy-policy"
                className="text-[#2AB7A6] hover:text-[#25A395] font-medium"
              >
                Privacy Policy →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
